<!--

SELECIONA PLANOS PARA PAGAMENTO DO APP NFE

-->

<template>
  <div class="registro">
    <header class="shared-header">
      <div class="col-md-12 col-12 text-center">
        <a class="valign" href="#">
          <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png">
        </a>
      </div>
    </header>

    <transition name="fade" mode="out-in">
      <div class="container-planos" v-if="!sucesso" style="margin-bottom: 100px">
        <div v-if="isEndTrial">
          <div class="activation text-center mb-2">
            <h3>Seu período de testes expirou!</h3>
          </div>
          <div class="activation text-center mb-2">
            <h3>Selecione agora um plano para continuar a utilizar o Nota Brasil</h3>
          </div>
        </div>

        <div id="NFE">
          <div class="text-center mb-5 mt-3">
            <div class="w-100 title">{{ renovacao ? 'Renovação do Plano' : 'Planos e Preços' }} </div>
          </div>

          <div class="steps">
            <div class="container-steps">
              <div class="steps-fluxo">
                <div :class="planSubscriptionSteps.length >= 1 ? 'item active' : 'item '">
                  <span>1</span>
                </div>
                <div :class="planSubscriptionSteps.length >= 2 ? 'connection active' : 'connection'"></div>
                <div :class="planSubscriptionSteps.length >= 2 ? 'item active' : 'item'">
                  <span>2</span>
                </div>
                <div :class="planSubscriptionSteps.length >= 3 ? 'connection active' : 'connection'"></div>
                <div :class="planSubscriptionSteps.length >= 3 ? 'item active' : 'item'">
                  <span>3</span>
                </div>
                <div :class="planSubscriptionSteps.length >= 4 ? 'connection active' : 'connection'"></div>
                <div :class="planSubscriptionSteps.length >= 4 ? 'item active' : 'item'">
                  <span>4</span>
                </div>
              </div>
              <div class="steps-texts position-relative d-none d-md-flex">
                <span class="w-100 text-center position-absolute" style="left:-300px">Escolha o plano</span>
                <span class="w-100 text-center position-absolute" style="left: -100px">Adicionar Complementos</span>
                <span class="w-100 text-center position-absolute" style="left: 100px">Faturamento</span>
                <span class="w-100 text-center position-absolute" style="left: 300px">Pagamento</span>
              </div>
            </div>
          </div>
          <nav class="nav" v-if="planSubscriptionSteps.length == 1">
            <div class="recorrencias-switch-toggle">
              <input v-if="hasRecorrencia('M')" type="radio" name="toggle" v-model="toggleRecorrencia" value="M"
                id="Mensal" />
              <label v-if="hasRecorrencia('M')" for="Mensal">Mensal</label>

              <input v-if="hasRecorrencia('T')" type="radio" name="toggle" v-model="toggleRecorrencia" :class="{ 'only2': !(hasRecorrencia('S')||hasRecorrencia('A')) }" value="T"
                id="Trimestral" />
              <label v-if="hasRecorrencia('T')" for="Trimestral" >Trimestral</label>

              <input v-if="hasRecorrencia('S')" type="radio" name="toggle" v-model="toggleRecorrencia" value="S"
                id="Semestral">
              <label v-if="hasRecorrencia('S')" for="Semestral">Semestral</label>

              <input v-if="hasRecorrencia('A')" type="radio" name="toggle" v-model="toggleRecorrencia" value="A"
                id="Anual">
              <label v-if="hasRecorrencia('A')" for="Anual">Anual</label>
              <div class="toggle-selector">&nbsp;</div>
            </div>
          </nav>
          <div class="container-bagde d-flex justify-content-start mb-5"
            v-if="credit && planSubscriptionSteps.length == 1">
            <span class="badge-credit">Seu crédito é de : R$ {{ credit }} </span>
          </div>
          <template v-if="planSubscriptionSteps.length == 1">

            <div class="container-planos-preco d-flex">
              <div v-for="(plan, index) in plans.planos" :key="index" class="box-custom">
                <div :title="plan.disabled ? 'Este plano não está disponivel' : null" @click="handleSelectPlan(index)"
                  :id="(index == 0) ? 'first' : ((index == plans.planos.length - 1) ? 'last' : `${plan.nome}`)"
                  v-if="plan.visible" :class="[!plan.recomendado && plan.disabled
                ?
                'card-plano-preco plan-disabled shadow'
                :
                !plan.recomendado && !plan.disabled
                  ?
                  'card-plano-preco  shadow '
                  :
                  'card-plano-preco-destaque shadow', plan.selected ? 'shadow-warning  border-warning' : '']">
                  <div class="w-100 text-right">
                    <div class="text-center">
                      <strong>{{ plan.nome }}</strong>
                      <i v-if="plan.selected" class="float text-warning text-center fa fa-thumb-tack"></i>
                    </div>
                    <div class="w-100 text-center text-stripe" v-if="!plan.disabled && credit">
                      <div class="stripe-content">de R${{ getprecoTotal(plan, toggleRecorrencia) }}
                      </div>
                    </div>
                  </div>

                  <div class="text-center mb-1">
                    <strong class="" v-if="plan.recorrencias.length > 0">R$
                      {{
                          !plan.disabled
                            ?
                            getPriceDesc(getprecoTotal(plan, toggleRecorrencia))
                            :
                            getprecoTotal(plan, toggleRecorrencia) | formatValue(2, true)
                      }}
                    </strong>
                    <small>/ {{ toggleRecorrencia == 'S' ? 'semestre' : toggleRecorrencia == 'T' ? 'trimestre' : toggleRecorrencia == 'A' ? 'anual' : 'mês'
                    }}
                    </small>
                  </div>
                  <div class="text-center mb-3" v-if="toggleRecorrencia == 'T' || toggleRecorrencia == 'S'">
                    <strong class="text-dark" style="font-size:23px" v-if="plan.recorrencias.length > 0">R$
                      {{
                          !plan.disabled
                            ?
                            getPriceDesc(getprecoMensal(plan, toggleRecorrencia))
                            :
                            getprecoTotal(plan, toggleRecorrencia) | formatValue(2, true)
                      }}
                    </strong>
                    <small>/ mês </small>
                  </div>
                  <div>
                    <a @click="handleSelectPlan(index)" v-if="!plan.disabled"
                      :class="!plan.recomendado && plan.disabled ? 'button-light-blue plan-disabled' : !plan.recomendado ? 'button-light-blue ' : 'button-green mt-4'">{{
                          !changePlan
                            || !renovacao ? 'Renovar' : 'Escolher'
                      }} Plano</a>
                  </div>
                  <ul>
                    <template v-if="plan.parametros && plan.parametros.recursos_landingpage && plan.parametros.recursos_landingpage.length > 0">
                      <li v-for="(item, i) in plan.parametros.recursos_landingpage" :key="'lp'+i">
                        <i class="fa fa-check-circle" style="color: #ACD22D; font-size:24px; z-index: 0;"></i>
                        <span class="ml-2 text-left" style="z-index:0;">{{ item }}</span>
                      </li>
                    </template>
                    <template v-else>
                      <li v-for="(rec, i) in plan.recursos" :key="i">
                        <i :class="rec.disabled ? 'fa fa-ban text-secondary' : 'fa fa-check-circle'"
                          style="color: #ACD22D; font-size:24px; z-index: 0;"></i>
                        <span :class="`ml-2 text-left text-left ${rec.disabled ? 'line-through ' : null}`"
                          style="z-index:0;">
                          <strong class="" v-if="!isNaN(rec.quantidade)">{{ rec.quantidade }}</strong>
                          <span class=""> {{ rec.nome }}</span>
                          <strong class="" v-if="isNaN(rec.quantidade)">{{ rec.quantidade }}</strong>
                        </span>
                        <div class="container-info" v-if="rec.tooltip && !plan.disabled">
                          <i class="fa fa-info-circle" style="color:#0C72AD" data-toggle="tooltip" data-placement="top"
                            :title="rec.tooltip"></i>
                        </div>
                      </li>
                    </template>
                  </ul>
                  <div class="badge-recomendado"
                    v-if="plan.id == currentPlan && toggleRecorrencia == currentRecorrencia.substr(0, 1)">Plano Atual
                  </div>
                </div>

              </div>
            </div>
            <div class="w-100">
              <PlanosCheckList :planos="plans" />
            </div>
          </template>

        </div>

        <div class="container mx-auto" style="margin-top:100px" v-if="false">
          <div class="row mb-3 text-center">
            <div class="col">
              <h2 class="ml-3">Perguntas Frequentes</h2>
            </div>
          </div>
          <div class="row duvidas">
            <div class="col-md-6">
              <div class="content">
                <p class="font-weight-bold">Quais são as formas de pagamento disponíveis?</p>
                <p>Você pode pagar o valor total do plano parcelado no cartão de crédito ou à vista no boleto.</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="content">
                <p class="font-weight-bold">O que acontece se acabar meu limite de emissão de notas?</p>
                <p>Caso seu limite de notas ficais no mês seja extrapolado, uma cobrança adicional será feita na próxima
                  renovação.</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="content">
                <p class="font-weight-bold">Tenho desconto se assinar a Conta Azul para mais de uma empresa?</p>
                <p>Para saber mais sobre esse benefício, fale com um de nossos especialistas no 0800 600 0920 ou
                  solicite
                  uma ligação de um consultor.</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="content">
                <p class="font-weight-bold">Posso contratar alguma funcionalidade de um plano superior?</p>
                <p>Para todos os planos pagos é possível contratar extensões: módulos de funcionalidade, pacote de
                  usuários ou espaço adicional para banco de dados ou anexos.</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="content">
                <p class="font-weight-bold">Posso cancelar a minha assinatura?</p>
                <p>Sua satisfação é muito importante para nós. Caso perceba que a Conta Azul não atende mais as suas
                  necessidades, vamos fazer de tudo para que você não vá embora insatisfeito. Mas lembre-se: conforme os
                  nossos termos de uso, você só vai receber devolução total dos valores se pedir o cancelamento em até 7
                  dias a partir do dia da compra independentemente do uso.</p>
              </div>
            </div>
          </div>
        </div>



        <div class="complementos " v-if="planSubscriptionSteps.length == 2">
          <div v-if="selectedPlan.addons.length > 0">
            <h3>Selecione funcionalidades adicionais para melhorar o seu plano</h3>
            <hr>
            <div>
              <div class=" border shadow my-3 component-addons" v-for="(comp, index) in selectedPlan.addons"
                :key="index">
                <div class="px-5 py-3 d-flex row align-items-center ">
                  <div class="d-flex col-6 align-items-start">
                    <input class="mr-5" style="width:16px; height: 16px" v-model="comp.selected" type="checkbox" name=""
                      id="">
                    <strong class="mr-4">{{ comp.nome }}</strong>
                  </div>

                  <div class="d-flex flex-col text-right align-items-center justify-content-end col-6 ">
                    <div class="line d-block mr-5" style="height:30px; opacity: 50%;"></div>
                    <strong class="text-right mx-5">R$ {{ comp.precoMensal | formatValue(2, true) }} / mês</strong>
                  </div>
                  <transition name="easeShow">
                    <small style="margin-left:80px; line-height: 0px;" v-if="comp.tooltip">{{ comp.tooltip }}</small>
                  </transition>
                </div>

              </div>
            </div>
          </div>
          <div v-else>
            <h3>Plano sem funcionalidades adicionais disponíveis</h3>
            <hr>
            <button :disabled="!selectedPlan" class="btn btn-success px-3" style="max-height:50px"
              @click="handleAddStepToPlan">Avançar</button>
          </div>
        </div>
        <div class="container-dados-faturamento" v-if="planSubscriptionSteps.length == 3">
          <h3>Informe seus dados para nota fiscal</h3>
          <div class="default-container mt-4">
            <div class="my-3">
              <label class="lbl-edit pb-1" for="">Tipo de Pessoa</label>
              <br>
              <input type="radio" v-model="dadosFaturamento.tppessoa" name="tppessoa" id="" value="F">
              <label class="lbl" for="">Pessoa Fisica</label>
              <input type="radio" v-model="dadosFaturamento.tppessoa" name="tppessoa" id="" value="J">
              <label class="lbl" for="">Pesso Juridica</label>
            </div>
            <div class="row">
              <form-field ref="nome" v-model="dadosFaturamento.nome" type="text" col="6" label="Nome" name="nome"
                :v-errors="errors" v-validate="{ required: true, max: 60, cpf: false }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento.tppessoa == 'J'">
              <form-field ref="cnpj" v-model="dadosFaturamento.cnpj" type="cnpj" col="3" label="CNPJ" name="cnpj"
                :v-errors="errors" v-validate="{ cnpj: true, cpf: false }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento.tppessoa == 'F'">
              <form-field ref="cpf" v-model="dadosFaturamento.cpf" type="number" col="3" label="CPF" name="cpf"
                :v-errors="errors" v-validate="{ cpf: true, cnpj: false }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.cep" type="cep" col="3" label="Cep" name="cep" :v-errors="errors"
                v-validate="{ required: true }" @update="updateCep"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.endereco" type="text" col="4" label="Endereço" name="ende"
                :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
              <form-field v-model="dadosFaturamento.nr" type="text" col="2" label="Número" name="endenr"
                :v-errors="errors" v-validate="{ required: true, max: 20 }"></form-field>
              <form-field v-model="dadosFaturamento.complemento" type="text" col="4" label="Complemento" name="endecomp"
                :v-errors="errors" v-validate="{ max: 40 }"></form-field>
            </div>

            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.bairro" type="text" col="4" label="Bairro" name="bairro"
                :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.uf" type="select2" col="4" label="Estado" name="uf"
                :v-errors="errors" v-validate="{ required: true }" :select2="{ entity: 'estado', minlength: 0 }">
              </form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.codmun" type="select2" col="4" label="Cidade" name="codmun"
                :v-errors="errors" v-validate="{ required: true }"
                :select2="{ entity: 'mun/uf/' + dadosFaturamento.uf, minlength: 2 }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.fone" type="fone" col="4" label="Telefone" name="fone"
                :v-errors="errors" v-validate="{ max: 15, required: true }"></form-field>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div v-if="sucesso">
        <div class="activation d-flex flex-column align-items-center text-center" style="gap:20px">
          <div>
            <i class="fa fa-check border-2 border-success bg-success bg-success text-light p-3 rounded-circle "
              style="font-size:22px"></i>
          </div>
          <h2 class="title">Sucesso!</h2>
          <h2 style="font-weight: normal" v-if="(pagseguro && pagseguro.plano == 'free')">Plano escolhido com sucesso.
          </h2>
          <h2 style="font-weight: normal" v-else>Estamos aguardando a confirmação do seu pagamento.</h2>
          <button type="button" class="app-button" @click="handleLogin"> Retornar ao Nota Brasil </button>
        </div>
      </div>
    </transition>

    <div class="bottom-bar" v-if="showComplementos">
      <div>
        <span>Total: R${{ resumo.total | formatValue }}</span>
      </div>
    </div>
    <div class="footer fixed-bottom shadow-lg overflow-x-hidden" v-if="!sucesso">
      <div class="footer-container my-3 lbl-gray" style="font-size:14px; font-weight:400">

        <button class="btn btn-outline-secondary px-3" style="max-height:50px"
          @click="handleBackStepToPlan">Voltar</button>

        <div class=" d-flex flex-wrap" v-if="selectedRecurso && selectedPlan"
          style="font-size:15px; color: black; font-weight: 500;">
          <div class="d-flex flex-column ">
            <div>
              <span>Resumo da compra:
                <strong>
                  <br class="d-none d-lg-block">
                  {{ selectedPlan.nome + ' ' }} {{ selectedRecurso.tipo }}
                </strong>
              </span> - <span>
                R$ {{ !selectedComplemento ? (getPriceDesc(selectedRecurso.precoTotal) / 12).toFixed(2) :
                    ((getPriceDesc(selectedRecurso.precoTotal) + (selectedComplemento.precoTotal * getBillingMethod)) /
                      getBillingMethod).toFixed(2) | formatValue(2, true)
                }}/mês
              </span>
            </div>
          </div>
          <div class="line mx-4 d-none d-lg-block"></div>
          <div class="d-flex h-auto h-lg-100 align-items-end" style="max-width: 210px">
            <span>Total: R$ {{ !selectedComplemento ? getPriceDesc(selectedRecurso.precoTotal) :
                getPriceDesc(selectedRecurso.precoTotal) + (selectedComplemento.precoTotal * getBillingMethod) |
                formatValue(2, true)
            }}
              <span class="d-none d-lg-block"> no boleto ou cartão de crédito </span><strong>em até 12x</strong>
            </span>
          </div>
        </div>

        <button :disabled="!(selectedRecurso && selectedPlan)" class="btn btn-success px-3" style="max-height:50px"
          @click="handleAddStepToPlan">Avançar</button>

      </div>
    </div>
  </div>
</template>

<script>
import { apiORDS, apiORDSapp } from '../shared/api-functions';
import { SysVars } from '../main';
import PlanosCheckList from '../components/planos-precos-checklist.vue';
import { isValidPostalCode } from '../shared/utils'

export default {
  components: {
    PlanosCheckList
  },
  props: {
    saldoPlanoAtual: { Type: Number },
    planoAtual: { Type: String },
  },
  data() {
    return {
      showTooltipComplemento: false,
      dadosFaturamento: {},
      hasValid: false,
      planSubscriptionSteps: [1],
      indexRecorrencias: 'M',
      toggleRecorrencia: 'M',
      renovacao: false,
      changePlan: false,
      currentPlan: null,
      currentRecorrencia: null,
      credit: 0,
      title: '',
      errmessages: null,
      sucesso: false,
      pagseguro: { code: null, link: null },

      periodoSelecionado: null,
      complementosSelecionados: null,
      showComplementos: false,
      resumo: {},
      plans: {},
      plano: {}

    }
  },

  computed: {
    getBillingMethod: function () {
      const tipoSelecionado = this.selectedRecurso.tipo

      return tipoSelecionado == 'ANUAL' ? 12 : tipoSelecionado == 'SEMESTRAL' ? 6 : tipoSelecionado == 'TRIMESTRAL' ? 3 : 1
    },
    selectedPlan: function () {
      let selected = null;
      if (this.plans && this.plans.planos && this.plans.planos.length > 0) {
        selected = this.plans.planos.find(plan => plan.selected === true);
      }
      return selected
    },
    selectedRecurso: function () {
      let selectedPlan = null;
      if (this.plans && this.plans.planos && this.plans.planos.length > 0) {
        selectedPlan = this.plans.planos.find(plan => plan.selected ? plan.selected : null);
      }
      let selectedRec = {}

      if (selectedPlan) {
        selectedRec = selectedPlan.recorrencias.find(rec => rec.selected ? rec.selected : null);
      }
      if (selectedPlan) {
        return selectedRec
      }
    },
    selectedComplemento: function () {
      const selectedPlan = this.plans.planos.find(plan => plan.selected);
      let selectedsComp = {
        addons: [],
        precoTotal: 0
      }

      if (selectedPlan) {
        selectedPlan.addons.forEach(comp => {
          if (comp.selected) {
            selectedsComp.addons.push(comp);
            selectedsComp.precoTotal = selectedsComp.precoTotal + comp.precoMensal
          }
        });
      }
      if (selectedsComp) {
        return selectedsComp
      }

    },
    isEndTrial: function () {
      return SysVars.appEndTrial
    },

    isBlocked: function () {
      return SysVars.appBlocked
    },

  },

  methods: {
    hasRecorrencia(tipo) {
      if (!this.plans || !this.plans.planos)
        return false

      return this.plans.planos.some(plano =>
        plano.recorrencias &&
        plano.recorrencias.some(recorrencia =>
          recorrencia.tipo && recorrencia.tipo.startsWith(tipo.toUpperCase())
        )
      )
    },
    getprecoMensal(plano, tipo) {
      const value = plano.recorrencias.find(obj => obj.tipo.startsWith(tipo))
      return value ? value.precoMensal : 0
    },

    getprecoTotal(plano, tipo) {
      const value = plano.recorrencias.find(obj => obj.tipo.startsWith(tipo))
      return value ? value.precoTotal : 0
    },
    handleShowTooltip(indice) {
      if (!this.selectedPlan.addons[indice].showTooltip) {
        this.$set(this.selectedPlan.addons[indice], 'showTooltip', true);
      } else {
        this.$set(this.selectedPlan.addons[indice], 'showTooltip', false);
      }
    },
    updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.dadosFaturamento.endereco = SysVars.endereco.logradouro;
      this.dadosFaturamento.bairro = SysVars.endereco.bairro;
      this.dadosFaturamento.codmun = SysVars.endereco.ibge;
      this.dadosFaturamento.uf = SysVars.endereco.uf;
    },
    async handleValidadados() {
      await this.$validator.validateAll().then(isValid => {
        this.hasValid = false
        if (!isValid || (!this.dadosFaturamento.cnpj && !this.dadosFaturamento.cpf)) {
          this.$refs.nome.focus()
          this.$erpToastError((!this.dadosFaturamento.cnpj && !this.dadosFaturamento.cpf) ? 'Por favor, verifique se o campo de CNPJ ou CPF e os demais campos estão preenchidos' : 'Por favor, corrija os campos em destaque para continuar');
        } else if (!isValid || (!this.selectedPlan && !this.selectedRecurso)) {
          this.$refs.nome.focus()
          this.$erpToastError((!this.selectedPlan && !this.selectedRecurso) ? 'Por favor, selecionar um plano' : 'Por favor, corrija os campos em destaque para continuar');
        } else if (!isValid || (!isValidPostalCode(this.dadosFaturamento.cep))) {
          this.$refs.nome.focus()
          this.$erpToastError((!isValidPostalCode(this.dadosFaturamento.cep)) ? 'Por favor, verifique se o campo CEP e os demais campos estão preenchidos corretamente' : 'Por favor, corrija os campos em destaque para continuar');

        } else {
          this.hasValid = true
        }
      })
    },
    handleBackStepToPlan() {
      const wrapDocument = document.getElementsByClassName('registro')[0]
      wrapDocument.scrollTop = 0;

      if (this.planSubscriptionSteps.length <= 1) {
        this.$router.push('/');
      }
      if (this.planSubscriptionSteps.length <= 2 && this.selectedComplemento) {
        this.loadDataPlans();

      }
      this.planSubscriptionSteps.pop();
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip();
      })
    },
    async handleAddStepToPlan() {
      const wrapDocument = document.getElementsByClassName('registro')[0]
      wrapDocument.scrollTop = 0;

      if (this.selectedPlan && this.selectedPlan.id == 'free') {
        while (this.planSubscriptionSteps.length <= 3) {
          this.planSubscriptionSteps.push(this.planSubscriptionSteps.length + 1)
        }
      }

      if (this.planSubscriptionSteps.length == 3) {
        await this.handleValidadados();
      }

      if (this.planSubscriptionSteps.length < 4) {
        if (this.planSubscriptionSteps.length == 3 && !this.hasValid) {
          return;
        }
        this.planSubscriptionSteps.push(this.planSubscriptionSteps.length + 1)
      }
      if ((this.planSubscriptionSteps.length == 2) && (this.selectedPlan && this.selectedPlan.addons.length <= 0)) {
        this.planSubscriptionSteps.push(this.planSubscriptionSteps.length + 1)
      }

      if (this.planSubscriptionSteps.length == 4) {
        this.handleAssinar();
      }


    },
    getPriceDesc(value) {
      if (value != 0 && this.credit) {
        return Math.abs(value - this.credit);
      } else {
        return value
      }
    },
    handleSelectPlan(indexPlan) {

      let indexRec = this.indexRecorrencias;

      this.plans.planos.forEach((plan, index) => {
        this.$set(this.plans.planos[index], 'selected', false)
        plan.recorrencias.map(el => {
          this.$set(el, 'selected', false)
        })

      })

      const plano = this.plans.planos[indexPlan]
      if (plano) {
        this.$set(plano, 'selected', true);
        const recorrencia = plano.recorrencias.find(obj => obj.tipo.startsWith(indexRec))
        if (recorrencia) {
          this.$set(recorrencia, 'selected', true)
        }

      }





    },
    loadParams() {
      let params = SysVars.planosParams;
      this.changePlan = null;
      this.renovacao = null;
      this.currentPlan = null;
      this.currentRecorrencia = null;
      this.credit = null;
      this.dadosFaturamento = null;

      if (params) {
        this.changePlan = params.trocaPlano;
        this.renovacao = params.renovacao
        this.currentPlan = params.planoAtual;
        this.currentRecorrencia = params.recorrencia;
        this.credit = params.valorCredito;
        this.dadosFaturamento = params.dadosFaturamento;
      }

      if (!this.dadosFaturamento) {
        this.dadosFaturamento = {
          tppessoa: 'J',
          nome: null,
          cnpj: '',
          cpf: '',
          cep: null,
          endereco: null,
          bairro: null,
          uf: null,
          codmun: null,
          complemento: null,
          nr: null,
          fone: null,
        };
      }

      if (!this.dadosFaturamento.tppessoa) {
        this.dadosFaturamento.tppessoa = 'J';
      }

    },
    setFeaturedPlan(index) {
      if (this.plans.planos) {
        this.loadParams();
        const plans = this.plans.planos;
        const currentPlan = `${this.currentPlan}`;
        const currentRecorrencia = `${this.currentRecorrencia}`;

        let hasFeatured = false;
        let indice = index ? index : 'M';

        if (this.changePlan || !this.renovacao) {

         const planSelected = plans.find(obj => obj.selected)
         plans.forEach((plan, i) => {

            if ((!planSelected) && (plan.id == this.plano.plano))
            {
             this.$set(plan, 'selected', true)
            }
            this.$set(plan, 'recomendado', false);
            this.$set(plan, 'disabled', true);

            const recorrencia = plan.recorrencias.find(obj => obj.tipo.startsWith(indice));
            const precoTotal = recorrencia ? recorrencia.precoTotal : 0

            if (plan.selected)  {
              this.currentRecorrencia = recorrencia.tipo;
              this.handleSelectPlan(i)
            }
            const credit = this.credit || 0
            if ((credit <= 0) || (credit > 0 && precoTotal > credit) && !(plan.id == currentPlan)) {
              this.$set(plan, 'disabled', false);

            }else{
              if (recorrencia) {
                this.$set(recorrencia, 'selected', false); // Atribuindo atriuto select para que atributo seja reativo ao DOM
              }
            }


            if (!plan.disabled && !hasFeatured) {

              if (currentPlan == plan.id) {
                return;
              }
              else {
                hasFeatured = true;
              }

            }


          })
        }
        else {

          this.credit = 0;

          for (let index = 0; index < plans.length; index++) {
            const plan = plans[index];
            if (!(plan.id == currentPlan)) {
              plans.splice(index, 1);
              index--
            }

          }

          if (!this.renovacao) {
            for (let index = 0; index < plans[0].recorrencias.length; index++) {
              const rec = plans[0].recorrencias[index];
              if (!(rec.tipo == currentRecorrencia)) {
                plans[0].recorrencias.splice(index, 1)
                index--
              }
            }
          }
          if (plans.length > 0) {
            this.$set(plans[0], 'disabled', false);
            this.$set(plans[0], 'selected', true);
            let firstLetter = currentRecorrencia ? currentRecorrencia.substr(0, 1) : 'M';
            let recIndex = plans[0].recorrencias.findIndex(rec => rec.tipo.startsWith(firstLetter));
            if (recIndex === -1) recIndex = 0;
            plans[0].recorrencias.forEach((rec, i) => {
              this.$set(rec, 'selected', i === recIndex);
            });
          }
        }



      }


    },
    async loadDataPlans() {

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
        this.unwatch = false
      })

      await apiORDSapp(this, 'sessao/meuplano/', 'get', null)
        .then((result) => {
          if (result && result.app && result.app.length > 0)
            this.plano = result.app[0]
          else
            this.plano = {}


        })


      if (this.plano && this.plano.tipo) {
        this.currentRecorrencia = this.plano.tipo;
        this.indexRecorrencias = this.currentRecorrencia.substr(0, 1);
        this.toggleRecorrencia = this.currentRecorrencia.substr(0, 1);
      }


      await apiORDS(this.$store.getters.urlApp + '/planos/')
        .then((data) => {
          let app = 'ERP5'
          if (this.plano.app) {
            app = this.plano.app;
          }
          this.plans = { ...data[app] };

          this.plans.planos.map(el => {
            this.$set(el, 'nome_tag', (el.app+"_"+el.id).toLowerCase().trim());
          })
        })
      if (this.changePlan || this.renovacao) {
        this.toggleRecorrencia = this.currentRecorrencia.substr(0, 1);
        this.setFeaturedPlan(this.toggleRecorrencia)
      }
      else {
        this.setFeaturedPlan();
      }

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })

    },
    handleSelectPeriodo(idx) {
      this.periodoSelecionado = idx
      this.periodos.map(p => p.selected = false)
      this.periodos[idx].selected = true;
      this.handleCalcValores();
    },

    handleLogin() {
      this.$router.push('/login');
    },

    handleInicio() {
      window.location.href = '/';
    },

    handleScrollTo() {
      const element = document.getElementById("complementos");
      element.scrollIntoView({
        behavior: "smooth"
      })
    },

    handleShowComplementos() {
      this.showComplementos = true
    },

    async handleAssinar() {
      let objeto = {}
      objeto.plano = this.selectedPlan.id;
      objeto.app = this.selectedPlan.app;
      objeto.recorrencia = this.toggleRecorrencia;
      objeto.trocaPlano = this.changePlan;
      objeto.complementos = new Array;

      this.selectedPlan.addons.forEach(ad => {
        if (ad.selected) {
          objeto.complementos.push({
            uuid: ad.uuid,
            quantidade: null
          });
        }
      });

      objeto.dadosFaturamento = this.dadosFaturamento
      if (this.dadosFaturamento.tppessoa == 'J')
        objeto.dadosFaturamento.cnpj = this.dadosFaturamento.cnpj
      else
        objeto.dadosFaturamento.cpf = this.dadosFaturamento.cpf

      this.$appLoading(true);
      let sendData = objeto


      this.pagseguro = await apiORDSapp(this, 'sessao/pagseguro/', 'post', sendData);
      this.$appLoading(false);


      let self = this

      if (this.pagseguro && this.pagseguro.plano == 'free') {
        var resultOptions = {};
        resultOptions.updateDataTable = false;
        self.sucesso = true;

        this.planSubscriptionSteps = [1]
      } else {

        window.open(this.pagseguro.link, "_self");
        self.$appLoading(false)
        var resultOptions = {};
        resultOptions.updateDataTable = false;
        self.sucesso = true;

        this.planSubscriptionSteps = [1]
      }

    }

  },
  watch: {
    toggleRecorrencia: {
      handler: function (n) {
        if (n) {
          this.indexRecorrencias = n
          this.setFeaturedPlan(n)
        }
        // this.plans.planos.find(plan => plan.selected = false)
      },

    }
  },
  async mounted() {
    this.loadParams();
    await this.loadDataPlans();

    this.$nextTick(() => {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()

    })

    setTimeout(function () {
      Tawk_API.hideWidget();
    }, 1000);

  },

  created() {
    // this.handleSelectPeriodo(0)
  }

}

</script>

<style scoped>
.component-addons {
  transition: all 0.5s ease;
}

@keyframes changeOpacity {
  0% {
    opacity: 0%;
  }

  40% {
    opacity: 40%;
  }

  100% {
    opacity: 100%;
  }
}

.easeShow-enter-actiejove {
  animation: changeOpacity 0.2s ease;
}


.easeShow-leave-active {
  animation: changeOpacity 0.2s reverse;

}

.default-container {
  padding-bottom: 9rem;
}

.line-through {
  text-decoration: line-through;
}

/* .tooltip-nb{
    display: none;
    position: absolute;
    top: -65px;
    word-break: break-all;
    text-align: center;
    width: 200px;
    z-index: 92;
    background: #0C72AD ;
    color: #fff;
    padding: 20px;
    transition: all 1s ease;
  }
  .tooltip-nb:after {
    content: '';
    position: absolute;
    top: 98%;
    left: 50%;
    margin-left:8px;
    width: 0;
    height: 0;
    border: 1px solid black;
    border-top: 8px;
    border-top-color: #0C72AD;
    border-right: 8px;
    border-right-color: #0C72AD;
    border-left: 8px;
    border-left-color: #0C72AD;
  }

}
.container-info:hover .tooltip-nb{
    display: block;
    transition: all 1s ease;
} */
.container-info {
  display: flex;
  text-align: right;
  align-self: center;
  margin-left: 5px;
  justify-content: center;
  z-index: 50;

}

.container-bagde {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: start;
  max-width: 720px;
  margin-top: 50px;
}

.container-dados-faturamento {
  width: 80%;

  margin: 50px auto;

  padding: 10px 20px;
  max-width: 1260px;
}

.connection {
  border: 4px solid #0f3e76;
  width: 100%;
  height: 10px;
  padding: 5px 0px;
  margin-left: -5px;
  z-index: 0;

}

.steps {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 80px;

}

.steps-fluxo {
  display: flex;
  width: 80%;
  margin: 0 auto;
  max-width: 650px;
  justify-content: space-between;
  align-items: center;
}

.steps-texts {
  display: flex;
  justify-content: center;
  gap: 9%;
  margin-top: 15px;
  font-weight: bold;
  font-size: 15px;
}

.steps-fluxo .item {
  border: 2px solid #0f3e76;
  border-width: 8px;
  padding: 5px 12px;
  border-radius: 50%;
  background: #fff;
  color: #0f3e76;
  font-size: 1.1rem;
  font-weight: bold;
  z-index: 1;
  margin-left: -5px;
}

.steps-fluxo .item.active {
  background: #0f3e76;
  color: white;
  border-left-color: #0f3e76;
}

.line {
  border: 1px solid rgba(128, 128, 128, 0.603);
}

.footer {
  background-color: #fff;
  z-index: 99999;
  overflow-x: hidden;
  max-height: 100px;
}

.footer .footer-container {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
}

.shadow-warning {
  box-shadow: 0 0.5rem 1rem #ffc107 !important;
}

.border-warning {
  border: 5px solid #ffc107 !important;
  transform: scale(1.05) !important;
  z-index: 100 !important;
  padding: 20px 15px !important;
}

.badge-credit {
  padding: 10px 20px;
  min-width: 100px;
  text-align: left;
  width: 250px;
  font-weight: 700;
  font-size: 0.8rem;
  color: white;
  border: 1px solid transparent;
  background-color: #0f3e76;
  border-radius: 20px;
}

.text-stripe .stripe-content {
  text-decoration: line-through;
  opacity: 75%;

}

.fita {
  background: #e51c46;
  position: relative;
  margin: 10px auto;
  right: 0px;
  width: 140px;
  color: #fff;
  line-height: 40px;
  height: 40px;
  font-size: 18px;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
}

.fita:before,
.fita:after {
  content: '';
  line-height: 0;
  border-style: solid;
  border-width: 14px;
  position: absolute;
  top: 22px;
  z-index: -2000;
  width: 8px;
}

.fita:before {
  border-color: #bc1438 #bc1438 #bc1438 transparent;
  left: -17px;
}

.fita:after {
  border-color: #bc1438 transparent #bc1438 #bc1438;
  right: -17px
}

.conteudo:before,
.conteudo:after {
  position: absolute;
  content: '';
  height: 0;
  line-height: 1px;
  border-style: solid;
  border-width: 5px;
  z-index: -1999;

}

.conteudo:before {
  border-color: #940d2a #940d2a transparent transparent;
  bottom: -10px;
  left: 0;
}

.conteudo:after {
  border-color: #940d2a transparent transparent #940d2a;
  bottom: -10px;
  right: 0;
}

.plan-disabled {
  background: rgba(83, 83, 83, 0.425) !important;
  opacity: 75%;
  cursor: not-allowed !important;
}

.plan-disabled:hover {
  transform: scale(1) !important;
  cursor: not-allowed !important;
}

.container-planos-preco {
  z-index: 90;
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-top: 2rem;

}

.card-plano-preco {
  z-index: 90;

  transition: transform 0.3s;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px 0;
  padding-left: 1.5rem;
  padding-right: 1rem;
  width: 280px;
  /* max-width: 290.33px; */
  min-height: 580px;
  height: 100%;
  cursor: pointer;
  border: 2px solid #CED1D5;
  transform: scale(1);
  background: white;
}

.card-plano-preco:hover {
  transform: scale(1.05);
  z-index: 9999;


}

.container-planos-preco #first {
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}

.container-planos-preco #last {
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}

.card-plano-preco-destaque {
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 253.33px;
  min-height: 580px;
  height: 100%;
  position: relative;
  padding-left: 1.25rem;
  padding-right: 0.5rem;
  margin-top: 1.25rem;
  border: 6px solid #ACD22D;
  border-radius: 16px;
  transform: scale(1);
  cursor: pointer;
}

.card-plano-preco-destaque:hover {
  transform: scale(1.05);

}

.card-plano-preco-destaque:hover~.button-green {
  border-color: #ACD22D !important;
  background-color: #fff !important;
  color: #ACD22D !important;
}

.card-plano-preco div strong,
.card-plano-preco-destaque div strong {
  font-weight: bold;
  font-size: 1.7rem;
  line-height: 130%;
  color: #0f3e76
}

.card-plano-preco div small,
.card-plano-preco-destaque div small {
  padding-left: 0.5rem;
  font-weight: 500;
  font-size: 0.75rem;
  color: #0f3e76;
  line-height: 130%;
}

.card-plano-preco div span,
.card-plano-preco-destaque div span {
  font-weight: 800;
  font-size: 0.813rem;
  line-height: none;
  color: #0f3e76
}

ul {
  padding-inline-start: 0px;
}

ul li {
  list-style: none;
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}

.card-plano-preco ul li span,
.card-plano-preco-destaque ul li span {
  font-size: 13px;
  color: #0f3e76;
  line-height: 130%;
  font-weight: 600;

}

.card-plano-preco-destaque ul li span {
  font-weight: 600;
  font-size: 14px;
  color: #0f3e76;
  line-height: 130%;

}

.card-plano-preco ul,
.card-plano-preco-destaque ul {

  margin: 10px 0;
}

.badge-recomendado {
  position: absolute;
  top: -30px;
  align-self: center;
  margin-right: 0.5rem;
  padding: 0.5rem 1.75rem;
  border: 1px solid transparent;
  border-radius: 40px;
  color: #fff;
  background: #ffc824;
  cursor: pointer;
}

.recorrencias-switch-toggle {


  background-color: #0f3e76;
  width: 90%;
  max-width: 660px;
  border-radius: 100px;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 0.5rem;
  margin: 0 auto;
  margin-top: 30px;
}

.recorrencias-switch-toggle input {
  display: none;
}

.recorrencias-switch-toggle label {
  width: 33.3%;
  margin: 0 auto;
  z-index: 5;
  font-weight: bold;
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  padding: 0.5rem 0;
  text-align: center;
}

.toggle-selector {
  left: 0px;
  transition: all 0.3s ease-in-out;
  background-color: #fff;
  position: absolute;
  width: 34%;
  top: 0px;
  height: 100%;
  border-radius: 100px;
  border: 3px solid;
  border-color: #0f3e76;
  z-index: 1;
}

#Mensal:checked+label {
  transition: 0.5s all;
  color: #0f3e76;
}

#Trimestral:checked+label {
  transition: 0.5s all;
  color: #0f3e76;
}

#Trimestral:checked~.toggle-selector {
  left: 32.2%;
}
#Trimestral.only2:checked~.toggle-selector {
  left: 66%;
}


#Semestral:checked+label {
  transition: 0.5s all;
  color: #0f3e76;
}

#Semestral:checked~.toggle-selector {
  left: 66%;
}

.shared-header {
  display: block;
  padding: 15px 0;
  margin-top: 15px;
}

.shared-header .valign {
  line-height: 30px;
  vertical-align: middle;
}

.activation {
  margin-top: 64px;
}

.activation h3 {
  margin-bottom: 32px;
  font-size: 54px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
  margin-top: 64px;
}

.activation h5 {
  margin-top: 30px;
  margin-bottom: 64px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
}

.activation-button {
  border: 2px solid #267da5 !important;
  /* border-radius: 3px!important; */
  border-radius: 0.70rem;
  margin-top: 50px;
  cursor: pointer;
  width: 200px !important;
  height: 45px !important;
  background-color: #267da5 !important;
  color: #fff !important;
  font-size: 15px !important;
}

.registro {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: block;
  transition: opacity .3s ease;
  overflow: auto;
}

.registro::-webkit-scrollbar-track {
  background-color: #F4F4F4;
}

.registro::-webkit-scrollbar {
  width: 3px;
  background: #F4F4F4;
}

.registro::-webkit-scrollbar-thumb {
  background: #dad7d7;
}

.container-planos {
  width: 100%;
  margin: auto;
}

.title {
  color: #222;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -1.13px;
  line-height: 44px;
}

.subtitle {
  color: gray;
  font-size: 1.1rem;
  line-height: 130%;
  font-weight: 400;
  text-align: center;
  width: 100%;
  margin-top: 10px
}

.title-price {
  display: inline-block;
  font-size: 18px;
  color: #151414;
  text-align: center;
  font-weight: 600;
}

.nav {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.navbar {
  padding: 0;
  border: 1px solid #d3d2d2;
  box-shadow: 0 5px 15px 0 rgba(82, 95, 127, .15);
}

.nav-link {
  color: #174B79;
  font-size: 1.5rem;
  /* font-weight: 700; */
  /* text-transform: uppercase; */
  padding: .5rem 2.5rem;
  cursor: pointer;
}

.nav-link:hover {
  color: #fff;
  background-color: #174B79;
}

.active {
  color: #fff;
  background-color: #174B79;
}

.card-wrapper {
  width: 90%;
  margin: auto;
}

.card {
  padding: 0 .25rem .5rem .25rem;
  border: none;
}

.card-content {
  font-size: 1.5rem;
  line-height: 24px;
  letter-spacing: -0.15px;
  border-radius: 0;
  border: 1px solid #d3d2d2 !important;
  box-shadow: 0 5px 15px 0 rgba(82, 95, 127, .15);
}

.card-content:hover {
  border: 2px solid #22f387 !important;
}

.card-title {
  font-size: 26px;
  color: #174B79;
  margin-top: 1.85rem;
}

.card-desconto {
  color: #b54848;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: line-through;
}

.card-price-info {
  color: #757575;
  font-size: 1.1rem;
}

.card-price {
  color: #1cc925;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: normal;
}

.card-periodo {
  color: #9ca5ac;
  font-size: 14px;
  /* font-weight: 500; */
  line-height: normal;
  padding: 0 2.3rem;
}

.card-action {
  width: 85%;
  margin: auto;
  padding: .75rem 0;
  border: 1px solid #e6d168;
  border-radius: 5px;
  background-color: #ffe871;
  cursor: pointer;
}

.card-button {
  color: #191919;
  text-align: center;
  text-decoration: none;
  /* text-transform: uppercase; */
  font-size: 1.3rem;
  /* font-weight: bold; */
  outline: none;
}

.card-button:hover {
  background-color: #ffe45f;
}

.card-info {
  padding: 1.5rem 2.3rem;
}

.card-info p {
  color: #385a7b;
  font-size: 1rem;
  /* font-weight: 500; */
  text-align: left;
  margin: .35rem 0;
}

.linethrough {
  color: #757575 !important;
  text-decoration: line-through;
}

.complementos-wrapper {
  width: 90%;
  margin: auto;
}

.complementos {
  width: 80%;
  min-height: 300px;
  margin: 50px auto;
  overflow: auto;
  padding: 10px 20px;
  max-width: 1260px;
}

.complementos .item-complementos {
  width: 100%;
  margin: 0 auto;
}

.complementos::-webkit-scrollbar-track {
  background-color: #F4F4F4;
}

.complementos::-webkit-scrollbar {
  width: 3px;
  background: #F4F4F4;
}

.complementos::-webkit-scrollbar-thumb {
  background: #dad7d7;
}

.comp-title {
  color: #385a7b;
  font-size: 1.5rem;
  font-weight: 500;
}

.complemento {
  margin: 0;
  padding: 0;
}

.complemento div {
  min-height: 120px;
  margin: .25rem;
  padding: .85rem;
  border: 1px solid #d3d2d2;
  box-shadow: 0 5px 5px 0 rgba(82, 95, 127, .15);
  cursor: pointer;
}

.selected {
  border: 2px solid #22f387 !important;
}

.complemento .desc {
  color: #385a7b;
  font-size: 1rem;
  /* font-weight: 500; */
  text-align: left;
  margin: .35rem 0;
}

.complemento .valor {
  color: #1cc925;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: normal;
}

.complemento .forma-pag {
  color: #757575;
}

.resumo {
  width: 100%;
  height: 510px;
  margin-top: .5rem;
  overflow: auto;
  border: 1px solid #d3d2d2 !important;
  box-shadow: 0 5px 15px 0 rgba(82, 95, 127, .15);
}

.resumo::-webkit-scrollbar-track {
  background-color: #F4F4F4;
}

.resumo::-webkit-scrollbar {
  width: 3px;
  background: #F4F4F4;
}

.resumo::-webkit-scrollbar-thumb {
  background: #dad7d7;
}

.resumo-wrapper {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  height: 100%;
}

.plano {
  border-bottom: 1px solid #d3d2d2 !important;
}

.plano-resumo {
  font-size: 1.3rem;
  font-weight: 500;
}

.plano span {
  color: #174B79;
  font-size: 1.3rem;
  font-weight: 500;
}

.plano small {
  color: #757575;
  font-size: .85rem;
  font-weight: 600;
  margin: 0;
}

.plano p {
  font-size: .85rem;
  line-height: .5rem;
  letter-spacing: .03rem;
  margin: 0;
}

.itens-resumo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  color: #385a7b;
}

.itens-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
  padding: .35rem 0;
  border-bottom: 1px solid #d3d2d2 !important;
}

.itens-resumo span {
  font-size: 1rem;
  line-height: 1.1rem;
}

.itens-resumo strong {
  font-size: 1rem;
  font-weight: 800;
  min-width: 27%;
  text-align: right;
}

.total-resumo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-resumo span {
  font-size: 1.3rem;
  font-weight: 900;
  text-transform: uppercase;
  margin-top: 1rem;
}

.btn-finalizar {
  color: #fff;
  font-size: 1.3rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: .75rem 13%;
  border: none;
  border-radius: 5px;
  background: #1cc925;
  cursor: pointer;
}

.btn-resumo:hover {
  background: #23bb2b;
}

.app-button {
  border: 2px solid #ffe871 !important;
  border-radius: 0.70rem;
  cursor: pointer;
  height: 45px !important;
  background-color: #ffe871 !important;
  color: black !important;
  font-size: 16px !important;
  font-weight: 600;
}

.box-clientes {
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid #E0E0E0; */
  /* border-radius: 15px; */
  padding: 15px;
  transition: all .2s;
  box-shadow: 0 5px 15px 0 #3a405048
}

.primary {
  background-color: #1cc925;
}

.periodo-info {
  font-size: 22px;
  letter-spacing: -0.15px;
  line-height: 24px;
}

.duvidas .content {
  font-size: 1rem;
  color: #385a7b;
  padding: 10px;
  margin-bottom: 1rem;
  cursor: pointer;
  border: 1px solid transparent;
}

.duvidas .content:hover {
  border: 1px solid #1cc925 !important;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  box-shadow: 0 5px 15px 0 #3a405048
}

.bottom-bar div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: .5rem;
  width: 50%;
  margin: auto;
}

.bottom-bar span {
  font-size: 1.3rem;
  font-weight: 800;
  margin: 0 .5rem;
  text-transform: uppercase;
}

.button-green {
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  width: 100%;
  height: 100%;
  max-width: 154px;
  max-height: 39px;
  background-color: #ACD22D;
  font-size: 1rem;
  line-height: 130%;
  padding: 9px 0;
  border: 1px solid transparent;
  border-radius: 50px;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
  text-decoration: none;
  font-weight: 600;

}

.button-green:hover {
  border-color: #ACD22D;
  background-color: #fff;
  color: #ACD22D;
}

.button-light-blue {
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  width: 100%;
  height: 100%;
  max-width: 154px;
  max-height: 39px;
  background-color: #fff;
  font-size: 1rem;
  line-height: 130%;
  padding: 9px 0;
  border: 1px solid #0f3e76;
  border-radius: 50px;
  color: #0f3e76;
  margin-left: auto;
  margin-right: auto;
  text-decoration: none;
  font-weight: 600;
}

.button-light-blue:hover {
  background-color: #0f3e76;
  color: #fff;
}

.card-plano-preco:hover~.button-light-blue {
  background-color: #0f3e76;
  color: #fff;
}

@media only screen and (max-width: 960px) {

  .card-wrapper {
    width: 100%;
    margin: 0;
  }

  .bottom-bar div {
    width: 60%;
  }

  .footer-container div {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    gap: 0;
    overflow-x: hidden;
  }
}

@media only screen and (max-width: 540px) {
  .line {
    display: none !important;
  }

  .container-planos-preco {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .container-planos-preco .box-custom {
    width: 100%;
  }

  .card-plano-preco {
    width: 90%;
    margin: 0 auto;
    max-width: 100%;
    border-radius: 20px;

  }

  .card-plano-preco-destaque {
    width: 90%;
    margin: 0 auto;
    max-width: 100%;
  }

  .card {
    padding: 0 1rem .5rem 1rem;
    border: none;
  }

  .nav {
    margin-top: 1rem;
  }

  .navbar {
    margin: 0 1rem;
  }

  .nav-link {
    font-size: .85rem;
    padding: .5rem 1.5rem;
  }

  .resumo-wrapper {
    padding: 1rem;
  }

  .complemento div {
    width: 100%;
    margin: 0;
  }

  .bottom-bar div {
    width: 90%;
    margin: auto;
    margin-top: .25rem;
  }

  .bottom-bar span {
    font-size: 1.2rem;
  }

  .btn-finalizar {
    font-size: 1rem;
    padding: .75rem 8%;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/app-planos-erp.vue